import { api } from '../api/client'

export interface TenantPrivilege {
  id: string
  status: boolean
  name: string
  description: string | null
  privilegesDetail: Record<string, unknown>
  createdBy: string | null
  modifiedBy: string | null
  createdAt: string
  modifiedAt: string
}

export interface CreateTenantPrivilegeBody {
  status?: boolean
  name: string
  description?: string
  privilegesDetail?: Record<string, unknown>
}

export interface UpdateTenantPrivilegeBody {
  status?: boolean
  name?: string
  description?: string
  privilegesDetail?: Record<string, unknown>
}

export interface TenantPrivilegesListResponse {
  tenantPrivileges: TenantPrivilege[]
  limit: number
  offset: number
  stats?: {
    total: number
    active: number
    critical: number
  }
}

export function useTenantPrivileges() {
  const list = async (limit = 50, offset = 0): Promise<TenantPrivilegesListResponse> => {
    const response = await api.get<TenantPrivilegesListResponse>(`/platform/tenant-privileges?limit=${limit}&offset=${offset}`)
    return response
  }

  const get = async (id: string): Promise<TenantPrivilege> => {
    const response = await api.get<TenantPrivilege>(`/platform/tenant-privileges/${id}`)
    return response
  }

  const create = async (body: CreateTenantPrivilegeBody): Promise<TenantPrivilege> => {
    const response = await api.post<TenantPrivilege>('/platform/tenant-privileges', body)
    return response
  }

  const update = async (id: string, body: UpdateTenantPrivilegeBody): Promise<TenantPrivilege> => {
    const response = await api.patch<TenantPrivilege>(`/platform/tenant-privileges/${id}`, body)
    return response
  }

  const remove = async (id: string): Promise<void> => {
    await api.delete(`/platform/tenant-privileges/${id}`)
  }

  return { list, get, create, update, remove }
}
